import { Button, Group, Select, Textarea } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './contact-form.module.css';

import { Drawer } from '@ui';

interface ContactFormValues {
  title: string;
  description: string;
}

interface ContactFormProps {
  onClose: () => void;
  opened: boolean;
  loading?: boolean;
  success?: boolean;
  onSubmit: (values: ContactFormValues) => void;
}

export function ContactForm({
  onClose,
  opened,
  onSubmit,
  loading,
  success,
}: ContactFormProps) {
  const { t } = useTranslation();
  const form = useForm<ContactFormValues>({
    initialValues: {
      title: '',
      description: '',
    },
  });

  const handleClose = () => {
    form.reset();
    onClose();
  };

  useEffect(() => {
    if (success) {
      form.reset();
    }
  }, [success]);

  return (
    <Drawer
      onClose={handleClose}
      opened={opened}
      position="right"
      size="auto"
      title={t('supportPage.contactUs')}
    >
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Select
          data={[
            t('supportPage.subjectInquiry'),
            t('supportPage.subjectBug'),
            t('supportPage.subjectOther'),
          ]}
          label={t('supportPage.contactSubject')}
          required
          {...form.getInputProps('title')}
        />

        <Textarea
          autosize
          label={t('supportPage.description')}
          minRows={3}
          mt="sm"
          required
          resize="vertical"
          {...form.getInputProps('description')}
        />

        <Group mt="xl">
          <Button loading={loading} type="submit">
            {t('common.save')}
          </Button>
          <Button color="red" onClick={handleClose} type="button">
            {t('common.cancel')}
          </Button>
        </Group>
      </form>
    </Drawer>
  );
}

export default ContactForm;
